export const FUTURE_BOUNDARY_DATES = {
  all: 'filters.date.future_dates_range.all',
  '3_days': 'filters.date.future_dates_range.3_days',
  '7_days': 'filters.date.future_dates_range.7_days',
  this_month: 'filters.date.future_dates_range.this_month',
  next_month: 'filters.date.future_dates_range.next_month',
};
export const PER_PAGE = { 25: 25, 50: 50, 100: 100 };
export const DEFAULT_PER_PAGE = 25;
export const LIVE_AUCTION_TYPE = 'live';
export const HAMMER_AUCTION_TYPE = 'hammer';



// WEBPACK FOOTER //
// ./app/javascript/packs/employees/auctions_catalogs/index/consts.js